var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title"}],staticClass:"pay-record",attrs:{"data-title":"业主钱包"}},[_c('section',[_c('landlord',{attrs:{"list":_vm.earnings_list}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }